import i18n from '@/plugins/i18n';
import { BaseNotification } from '@notify/models/notification/types/base';

export class RatesUpdate extends BaseNotification {
  constructor(data) {
    super(data);
  }

  getText() {
    const props = this.getI18nProps();
    const link = props.link;
    const label = link.label;

    const params = {
      type: i18n.t(props.params.type),
      link: `<a href="/prices" style="color: #fff;text-decoration: underline;">${i18n.t(label)}</a>`
    };
    return i18n.t(props.path, params);
  }

  getTheme() {
    return BaseNotification.THEME_INFO;
  }

  getI18nProps() {
    const params_type = this.params.type || 'default';
    const link_type = this.params.type || 'index';
    const link = { name: `core.price.type`, params: { type: link_type } };

    return {
      path: `notify.notification.rates_update.body`,
      params: {
        type: `notify.notification.rates_update.type.${params_type}`
      },
      link: {
        href: link,
        label: 'notify.notification.rates_update.link.label'
      }
    };
  }
}
